import { ConnectorType, ConnectorSource } from '@hum/icm-app/src/state';
import { AvailableServiceInfo } from './base';

export const klarnaDirectConnector: AvailableServiceInfo = {
  label: 'Klarna',
  icon: require('./klarna.svg'),
  isBeta: true,
  type: ConnectorType.Klarna,
  source: ConnectorSource.Capital,
  fields: [
    {
      label: 'Enter your username',
      propertyName: 'username',
    },
    {
      label: 'Enter your password',
      propertyName: 'password',
    },
  ],
  connect: (params) => params,
};
